import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainImage", "mainVideo", "thumbnail", "counter", "arrowLeft", "arrowRight"]
  static values = { currentIndex: Number }

  connect() {
    this.isTransitioning = false
    this.totalItems = this.mainImageTargets.length + (this.hasMainVideoTarget ? 1 : 0)
    if (typeof this.currentIndexValue === 'undefined') this.currentIndexValue = 0
    if (this.totalItems > 1) {
      if (this.hasArrowLeftTarget) this.arrowLeftTarget.classList.remove("invisible")
      if (this.hasArrowRightTarget) this.arrowRightTarget.classList.remove("invisible")
    }
    this.updateGallery()
  }

  next() {
    if (this.currentIndexValue < this.totalItems - 1 && !this.isTransitioning) {
      const dir = document.documentElement.dir === 'rtl' ? "right" : "left"
      this.slideTo(this.currentIndexValue, this.currentIndexValue + 1, dir)
    }
  }

  previous() {
    if (this.currentIndexValue > 0 && !this.isTransitioning) {
      const dir = document.documentElement.dir === 'rtl' ? "left" : "right"
      this.slideTo(this.currentIndexValue, this.currentIndexValue - 1, dir)
    }
  }

  selectImage(event) {
    const index = parseInt(event.currentTarget.dataset.index)
    if (!this.isTransitioning && index !== this.currentIndexValue) {
      const isRtl = document.documentElement.dir === 'rtl'
      const dir = index > this.currentIndexValue
        ? (isRtl ? "right" : "left")
        : (isRtl ? "left" : "right")
      this.slideTo(this.currentIndexValue, index, dir)
    }
  }

  videoIndex() {
    return this.hasMainVideoTarget ? this.mainImageTargets.length : -1
  }

  updateGallery() {
    this.mainImageTargets.forEach((image, index) => {
      image.classList.remove("absolute", "inset-0", "z-20", "z-10", "transition-all", "duration-300", "translate-x-0", "translate-x-full", "-translate-x-full")
      if (index === this.currentIndexValue) {
        image.classList.remove("hidden")
      } else {
        image.classList.add("hidden")
      }
    })
    if (this.hasMainVideoTarget) {
      if (this.currentIndexValue === this.videoIndex()) {
        this.mainVideoTarget.classList.remove("hidden")
      } else {
        this.mainVideoTarget.classList.add("hidden")
      }
    }
    this.thumbnailTargets.forEach((thumbnail, index) => {
      if (index === this.currentIndexValue) {
        thumbnail.classList.remove("border-gray-200", "hover:border-trust-deep", "ring-0")
        thumbnail.classList.add("border-trust-deep", "ring-2", "ring-trust-deep")
      } else {
        thumbnail.classList.remove("border-trust-deep", "ring-2", "ring-trust-200")
        thumbnail.classList.add("border-gray-200", "hover:border-trust-deep", "ring-0")
      }
    })
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = this.currentIndexValue + 1
    }
    if (this.hasArrowLeftTarget) {
      this.arrowLeftTarget.classList.toggle("invisible", this.currentIndexValue === 0)
    }
    if (this.hasArrowRightTarget) {
      this.arrowRightTarget.classList.toggle("invisible", this.currentIndexValue === this.totalItems - 1)
    }
  }

  slideTo(from, to, direction) {
    this.isTransitioning = true
    const vidIdx = this.videoIndex()

    if (this.hasArrowLeftTarget) {
      this.arrowLeftTarget.classList.toggle("invisible", to === 0)
    }
    if (this.hasArrowRightTarget) {
      this.arrowRightTarget.classList.toggle("invisible", to === this.totalItems - 1)
    }

    if (to === vidIdx || from === vidIdx) {
      this.currentIndexValue = to
      this.isTransitioning = false
      this.updateGallery()
      return
    }

    const fromImg = this.mainImageTargets[from]
    const toImg = this.mainImageTargets[to]
    fromImg.classList.remove("hidden")
    toImg.classList.remove("hidden")
    fromImg.classList.add("absolute", "inset-0", "z-20", "transition-all", "duration-300")
    toImg.classList.add("absolute", "inset-0", "z-10", "transition-all", "duration-300")
    fromImg.classList.remove("translate-x-0", "-translate-x-full", "translate-x-full")
    toImg.classList.remove("translate-x-0", "-translate-x-full", "translate-x-full")
    if (direction === "left") {
      toImg.classList.add("translate-x-full")
      setTimeout(() => {
        toImg.classList.remove("translate-x-full")
        toImg.classList.add("translate-x-0")
        fromImg.classList.add("-translate-x-full")
      }, 20)
    } else {
      toImg.classList.add("-translate-x-full")
      setTimeout(() => {
        toImg.classList.remove("-translate-x-full")
        toImg.classList.add("translate-x-0")
        fromImg.classList.add("translate-x-full")
      }, 20)
    }
    setTimeout(() => {
      fromImg.classList.remove("absolute", "inset-0", "z-20", "transition-all", "duration-300", "translate-x-full", "-translate-x-full", "translate-x-0")
      fromImg.classList.add("hidden")
      toImg.classList.remove("absolute", "inset-0", "z-10", "transition-all", "duration-300", "translate-x-full", "-translate-x-full")
      this.currentIndexValue = to
      this.isTransitioning = false
      this.updateGallery()
    }, 330)
  }

  currentIndexValueChanged() {
    this.updateGallery()
  }
}
